import React from 'react';
import { PureQueryOptions } from '@apollo/client';
import RequestAbsenceSidebar from '../RequestAbsenceSidebar';
import { useProfileWidgetAbsenceCategoriesQuery } from '../../__generated__/graphql';
import { mapEmployeeAbsenceCategoryToAbsenceCategory } from '../RequestAbsenceSidebar/mappings';

type Props = {
  show: boolean;
  onClose: () => void;
  absenceId: string;
  absenceCategoryId: string;
  onSuccess?: () => void;
  refetchQueries?: PureQueryOptions[];
};

const EditAbsenceSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  show,
  onClose,
  absenceId,
  absenceCategoryId,
  onSuccess,
  refetchQueries,
}) => {
  const { data: absenceCategoriesData } =
    useProfileWidgetAbsenceCategoriesQuery();

  const absenceCategories = (
    absenceCategoriesData?.me?.absenceCategories || []
  ).map(mapEmployeeAbsenceCategoryToAbsenceCategory);

  return (
    <RequestAbsenceSidebar
      show={show}
      onClose={onClose}
      absenceId={absenceId}
      absenceCategoryId={absenceCategoryId}
      absenceCategories={absenceCategories}
      onSuccess={onSuccess}
      refetchQueries={refetchQueries}
    />
  );
};

export default EditAbsenceSidebar;
